module.exports = __webpack_public_path__ + "img/3e38ae2.png";